module.exports = __webpack_public_path__ + "img/t-1.0d88cb2c.jpg";